module.exports = {
  '@@functional/placeholder': true
};